import { Dropdown as uuiDropdown } from '@epam/uui-components';
import { DropdownProps, withMods } from '@epam/uui-core';

export const Dropdown = withMods<DropdownProps, DropdownProps>(uuiDropdown);
